import fonts from "./fonts.sdb.theme.js";
import breakpoints from "./breakpoints.sdb.theme.js";
import systemTokens from "./systemTokens/index.js";
export const getSdbTheme = () => ({ fonts, breakpoints, systemTokens });
export default getSdbTheme;
